module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.5487bea9.eot";